import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Link extends Component {
  static propTypes = {
    card: PropTypes.object.isRequired,
  }

  render() {
    let tags = this.props.card.tags.map( ( tag ) => (
        <span className="inline-block bg-grey-lighter rounded-full px-3 py-1 text-sm font-semibold text-grey-darker mr-2 mb-2">{ tag }</span>
    ) );

    let image = ( this.props.card.video ? (
        <video className="w-full h-48 sichkovskyi__image" src={ this.props.card.video } alt={ this.props.card.imageAlt } loop={true} autoPlay={true}></video>
    ) : (
        <img className="w-full h-48 sichkovskyi__image" src={ this.props.card.image } alt={ this.props.card.imageAlt }></img>
    ) );

    return (
    <a href={ this.props.card.link } target="_blank" rel="noopener noreferrer" className="sichkovskyi__work-card rounded overflow-hidden shadow-md hover:shadow-lg text-grey-darkest no-underline bg-white md:ml-4 mb-6 md:mb-4">
        <div className="w-full h-48 overflow-hidden">
            { image }
        </div>
        <div className="px-6 py-4">
            <div className="font-bold text-xl mb-2">{ this.props.card.title }</div>
            <p className="text-grey-darker text-base">
                { this.props.card.body }
            </p>
        </div>
        <div className="px-6 py-4">
            { tags }
        </div>
    </a>
    )
  }
}
